/* eslint-disable react/require-default-props */
import React, { type ReactElement } from 'react';
import { ApplicationIcon, Box, Typography } from '@saviynt/design-system';
import cx from 'classnames';

import { CF_SEC_BLD } from '../../constants';
import { getLogoEndpointUrl } from '../../utils';

import './SodApplicationGroup.css';

interface SodApplicationGroupProps {
  label: string;
  firstLogo?: string;
  secondLogo?: string;
  count?: number;
}

/**
 * For use in AAG list rows to display a group of applications.
 *
 * @param label - The label to display
 * @param firstLogo - The first logo to display
 * @param secondLogo - The second logo to display (optional)
 * @param count - The number of applications apart from first one in the group
 *
 * * TODO
 * - Add tests once there are acutal data points to map with
 */
function SodApplicationGroup({
  label,
  firstLogo,
  secondLogo,
  count = 1,
}: SodApplicationGroupProps): ReactElement {
  const wrapperClasses = cx(
    'SodApplicationGroup',
    count === 1 && 'SodApplicationGroup--isCountOne'
  );

  const firstUrl = getLogoEndpointUrl(firstLogo);
  const secondUrl = getLogoEndpointUrl(secondLogo);

  return (
    <Box className={wrapperClasses}>
      <Box className='SodApplicationGroup-icons'>
        {firstUrl ? (
          <ApplicationIcon
            size='xxSmall'
            className='SodApplicationGroup-icon1'
            src={firstUrl}
          />
        ) : (
          <ApplicationIcon
            logo={firstLogo}
            size='xxSmall'
            className='SodApplicationGroup-icon1'
          />
        )}
        {secondLogo && (
          <ApplicationIcon
            logo={secondLogo}
            size='xxSmall'
            className='SodApplicationGroup-icon2'
            src={secondUrl}
          />
        )}
      </Box>
      <Typography kind='body2'>{label}</Typography>
      {count > 1 && (
        <Typography kind='body2-bold' color={CF_SEC_BLD}>{`+${
          count - 1
        }`}</Typography>
      )}
    </Box>
  );
}

export default SodApplicationGroup;
